import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react';

import { DesignLayout } from '@common/DesignLayout';
import { dataControlStore } from '@stores/dataControlStore';
import { fetchReferences } from '@stores/dictionaryStores/fetchReferences';

import { Breadcrumbs } from './Breadcrumbs';
import { ControlLevel } from './ControlLevel';
import { Filters } from './Filters';
import { GeneralReport } from './GeneralReport';
import { InfoDrawer } from './InfoDrawer';
import { PackageLevel } from './PackageLevel';
import { StepLevelModal } from './StepLevelModal';
import { usePassingControlStorage } from './usePassingControlStorage';

import styles from './DataControl.module.scss';

// Последовательность "Общий отчет (GeneralReport)" -> "Уровень пакета (PackageLevel)" -> "Уровень контроля (ControlLevel)" -> "Уровень шага (StepLevelModal)" -> "Детализация ошибок (ErrorDetailsModal) (временно убрали)"

export const DataControl = observer(() => {
  const { lastPagesParam, clear } = dataControlStore;

  useEffect(() => {
    fetchReferences(['periods', 'reportGroups', 'organizations']);
  }, []);

  usePassingControlStorage();

  useEffect(
    () => () => {
      clear();
    },
    [clear],
  );

  const render = useMemo(() => {
    switch (lastPagesParam.controlType) {
      case 'generalReport':
        return <GeneralReport />;
      case 'packageLevel':
        return <PackageLevel />;
      case 'controlLevel':
        return <ControlLevel />;
      case 'stepLevel':
        return <StepLevelModal />;
      // case 'errorDetails':
      //   return <ErrorDetailsModal />;
      default:
        return null;
    }
  }, [lastPagesParam.controlType]);

  return (
    <DesignLayout>
      <>
        <div className={styles.forms}>
          <Filters />
          <Breadcrumbs />
          {render}
        </div>
        <InfoDrawer />
      </>
    </DesignLayout>
  );
});
